import {
	APPLY_CUPOM_SUCCESS,
	APPLY_CUPOM_ERROR,
	REMOVE_CUPOM_SUCCESS,
	REMOVE_CUPOM_ERROR
} from '../../actionType';

import { discount } from '../api';
import { errorGetOrderValue } from '../order';

export const successApplyCupom = payload => ({
	type: APPLY_CUPOM_SUCCESS,
	payload
});

export const errorApplyCupom = payload => ({
	type: APPLY_CUPOM_ERROR,
	payload
});

export const successRemoveCupom = payload => ({
	type: REMOVE_CUPOM_SUCCESS,
	payload
});

export const errorRemoveCupom = payload => ({
	type: REMOVE_CUPOM_ERROR,
	payload
});

export const applyCupom = (orderId, cupomId, origin) => async dispatch => {
	const response = await discount.apply({ orderId, cupomId, origin });
	let error = null;

	if (response.status === 200) {
		dispatch(successApplyCupom(response.data));
		dispatch(errorGetOrderValue({}));
		error = false;
	} else {
		dispatch(errorApplyCupom(response.data));
		error = true;
	}
	return error;
};

export const removeCupom = cuponsUsedId => async dispatch => {
	const response = await discount.remove(cuponsUsedId);
	let error = null;

	if (response.status === 200) {
		dispatch(successRemoveCupom(response.data));
		dispatch(errorGetOrderValue({}));
		error = false;
	} else {
		dispatch(errorRemoveCupom(response.data));
		error = true;
	}
	return error;
};

export const clearCupomError = data => dispatch => {
	if (data.error === 'Error removing cupom.') {
		data.error = 'Remove error';
		dispatch(errorRemoveCupom(data));
	} else {
		dispatch(successApplyCupom({}));
	}
};
